module.exports = __webpack_public_path__ + "static/img/modal_bg3.1237390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bg3.png
// module id = qgKO
// module chunks = 1